// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"09252976","455":"0430d14f","560":"8d594f20","977":"01b7b8fe"}[chunkId] + ".chunk.js";
};